import { ForgotForm } from "@features/account-recovery";

export const ForgotPage = () => <ForgotForm />;
